// src/services/Villages.service.js
import api from './api';

const villageService = {
  getAllVillages: async (filters = {}) => {
    const params = {};
    if (filters.companyId)     params.companyId = filters.companyId;
    if (filters.regionId)      params.regionId = filters.regionId;
    if (filters.headquarterId) params.headquarterId = filters.headquarterId;
    if (filters.status)        params.status = filters.status;
    const res = await api.get('/villages', { params });
    return res.data;
  },

  getVillageById: async (id) => {
    const res = await api.get(`/villages/${id}`);
    return res.data;
  },

  getVillagesByHeadquarter: async (headquarterId) => {
    const res = await api.get(`/villages/headquarter/${headquarterId}`);
    return res.data;
  },

  createVillage: async (payload) => {
    const res = await api.post('/villages', payload);
    return res.data;
  },

  updateVillage: async (id, payload) => {
    const res = await api.post(`/villages/${id}`, payload);
    return res.data;
  },

  deleteVillage: async (id) => {
    const res = await api.delete(`/villages/${id}`);
    return res.data;
  },

  createVillage: async (payload) => {
  // payload: { externalId, villageCode, name, stateName, ..., headquarterIds[], companyId? }
  const res = await api.post('/villages', payload);
  return res.data;
},

getVillagesByHeadquarter: async (headquarterId, companyId) => {
  const params = { headquarterId };
  if (companyId) params.companyId = companyId;
  const res = await api.get('/villages/by-hq', { params });
  return res.data;
},
};

export default villageService;